import { ThemeProvider } from '@material-ui/core';
import { createTheme } from "@material-ui/core/styles";
import axios from "axios";
import MaterialTable from "material-table";
import { Component } from "react";
import { Button, Card, Form, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import { FaCheckCircle, FaHourglassHalf, FaPencilAlt } from "react-icons/fa";
import ConfirmModal from "../../utils/ConfirmModal";
import { downloadCSV } from "../../utils/csvDownload";
import MeasurementBillPDF from "../../utils/MeasurementBillPDF";
import { hasPermission } from "../../utils/usePermission";
import CommonLoader from "../loaderComponent/CommonLoader";
import CommonToast from "../Toaster/CommonToast";

export default class MeasurementBillList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      measurementBills: [],
      woItems: [],
      mbNumber: "",
      mbDate: "",
      customerId: "",
      projectId: "",
      workOrderId: "",
      status: "pending",
      loading: true,
      showToast: false,
      toastMessage: "",
      toastVariant: "",
      showConfirm: false,
      deleteId: null,
      showModal: false,
      selectedMeasurement: null,
      newStatus: "",
      color: '',
      completed: false,
      measurementBillPrint: []
    };
  }

  openConfirmModal = () => {
    this.setState({ showConfirm: true });
  };

  closeConfirmModal = () => {
    this.setState({ showConfirm: false });
  };

  componentDidMount() {
    this.fetchMeasurementBills();
  }

  fetchMeasurementBills = () => {
    this.setState({ loading: true });
    axios
      .get("/measurementBill")
      .then((res) => {
        this.setState({ measurementBills: res.data, loading: false });
      })
      .catch((error) => {
        this.setState({
          loading: false,
          showToast: true,
          toastMessage: error.response?.data?.message || "Error fetching measurement bills",
          toastVariant: "danger",
          color: 'red'
        });
      });
  };

  handleDelete = () => {
    axios
      .delete(`/measurementBill/${this.state.deleteId}`)
      .then(() => {
        this.setState({
          showToast: true,
          toastMessage: "Measurement Bill deleted successfully",
          toastVariant: "success",
          color: 'green',
          deleteId: null,
          showConfirm: false,
        });
        this.fetchMeasurementBills();
      })
      .catch((error) => {
        this.setState({
          showToast: true,
          toastMessage: error.response?.data?.message || "Error deleting measurement bill",
          toastVariant: "danger",
          color: 'red',
          deleteId: null,
          showConfirm: false,
        });
      });
  };


  handleEdit = (rowData) => {
    const { id } = rowData;
    this.props.history.push(`/measurement-bill-edit/${id}`, { data: rowData });
  };

  handleMoveAdd = () => {
    this.props.history.push('/measurement-bill-add')
  }

  handleView = (rowData, viewPage) => {
    const { id } = rowData;
    this.props.history.push(`/measurement-bill-view/${id}`, { data: rowData, viewPage });
  };

  fetchMeasurementBill = async (id) => {
    this.setState({ loading: true });

    try {
      const res = await axios.get(`/measurementBill/${id}`);
      this.setState({ measurementBillPrint: res.data, loading: false, completed: true });
    } catch (error) {

    }
  }

  // fetchMeasurementBill = (id) => {
  //   return axios
  //     .get(`/measurementBill/${id}`)
  //     .then((res) => {
  //       const mb = res.data;
  //       this.setState({
  //         mbNumber: mb.mbNumber,
  //         mbDate: mb.mbDate,
  //         customerId: mb.customerId,
  //         projectId: mb.projectId,
  //         workOrderId: mb.workOrderId,
  //         status: mb.status,
  //         loading: false,
  //         completed: true,
  //         woItems: mb.items.map((item) => ({
  //           workOrderItemId: item.workOrderItemId,
  //           labourName: item.workOrderItem?.labour?.name,
  //           askedQuantity: item.workOrderItem.quantity,
  //           serialNumber: item.workOrderItem.serialNumber,
  //           pendingQuantity: item.workOrderItem.pendingQuantity,
  //           uom: item.uom,
  //           quantity: item.quantity,
  //         })),
  //       }, () => {
  //         setTimeout(() => {
  //           this.setState({ loading: false });
  //         }, 900);
  //       });

  //       return mb;
  //     })
  //     .catch((err) => {
  //       console.error("Error fetching measurement bill:", err);
  //       this.setState({
  //         showToast: true,
  //         toastMessage: "Failed to load measurement bill data",
  //         toastVariant: "danger",
  //         color: 'red'
  //       });
  //       setTimeout(() => {
  //         this.setState({ loading: false });
  //       }, 900);
  //       return null;
  //     });
  // };

  fetchMeasurementBillView = (id) => {
    return axios
      .get(`/measurementBill/view/${id}`)
      .then((res) => {
        const mb = res.data;
        this.setState({
          mbNumber: mb.mbNumber,
          mbDate: mb.mbDate,
          customerId: mb.customerId,
          projectId: mb.projectId,
          workOrderId: mb.workOrderId,
          status: mb.status,
          woItems: mb.items.map((item) => ({
            workOrderItemId: item.workOrderItemId,
            labourName: item.workOrderItem?.labour?.name,
            askedQuantity: item.workOrderItem.quantity,
            serialNumber: item.workOrderItem.serialNumber,
            pendingQuantity: item.workOrderItem.pendingQuantity,
            uom: item.uom,
            quantity: item.quantity,
          })),
        }, () => {
          setTimeout(() => {
            this.setState({ loading: false });
          }, 900);
        });

        return mb;
      })
      .catch((err) => {
        console.error("Error fetching measurement bill:", err);
        this.setState({
          showToast: true,
          toastMessage: "Failed to load measurement bill data",
          toastVariant: "danger",
          color: 'red'
        });
        setTimeout(() => {
          this.setState({ loading: false });
        }, 900);
        return null;
      });
  };

  handlePrint = async (rowData) => {
    // debugger;
    const companyInfo = {
      name: rowData.customer.name,
      project: rowData.project.name,
    }
    try {
      await this.fetchMeasurementBill(rowData.id);
      // Convert image to base64
      // const response = await fetch(LogoPath);
      // const blob = await response.blob();
      const logoBase64 = ''
      // const logoBase64 = await new Promise((resolve) => {
      //   const reader = new FileReader();
      //   reader.onloadend = () => resolve(reader.result);
      //   reader.readAsDataURL(blob);
      // });
      if (this.state.completed && this.state.measurementBillPrint) {
        await MeasurementBillPDF.generate(this.state.measurementBillPrint, logoBase64, companyInfo);
      }

    } catch (error) {
      console.error('Failed to generate PDF:', error);
      alert('Failed to generate PDF. Please check console for details.');
    }
  };

  handlePrintAll = () => {
    const { measurementBills } = this.state
    if (measurementBills) {
      downloadCSV(measurementBills, "Measurement_Bills_Info");
    }
  }

  handleStatusChange = (data) => {
    this.setState({ showModal: true, selectedMeasurement: data, newStatus: data.status });
  };

  handleStatusUpdate = () => {
    const { selectedMeasurement, newStatus } = this.state;

    if (!newStatus) {
      this.setState({
        showToast: true,
        toastMessage: "Please select a status!",
        toastVariant: "danger",
        color: 'red'
      });
      return;
    }

    const payload = {
      customerId: selectedMeasurement.customerId,
      projectId: selectedMeasurement.projectId,
      workOrderId: selectedMeasurement.workOrderId,
      mbNumber: selectedMeasurement.mbNumber,
      mbDate: selectedMeasurement.mbDate,
      status: newStatus,
      items: selectedMeasurement.items,
    }

    axios.put(`measurementBill/${selectedMeasurement.id}`, payload, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    }).then(() => {
      this.setState({
        showToast: true,
        toastMessage: "Status updated successfully!",
        toastVariant: "success",
        color: 'green',
        showModal: false
      });
      this.fetchMeasurementBills();
    }).catch(() => {
      this.setState({
        showToast: true,
        toastMessage: "Failed to update status!",
        toastVariant: "danger",
        color: 'red'
      });
    });
  };

  render() {
    const { measurementBills, loading, showToast, toastMessage, toastVariant } = this.state;
    const theme = createTheme({
      overrides: {
        MuiTableCell: {
          root: {
            padding: '6px 6px 6px 6px'
          }
        }
      }
    })

    return (
      <>
        <CommonToast
          show={showToast}
          onClose={() => this.setState({ showToast: false })}
          message={toastMessage}
          variant={toastVariant}
          color={this.state.color}
        />
        <ConfirmModal
          show={this.state.showConfirm}
          onHide={() => this.setState({ showConfirm: false, deleteId: null })}
          onConfirm={() => this.handleDelete()}
          title="Delete Confirmation"
          message="Are you sure you want to delete this Measurement Bill?"
        />
        <CommonLoader isLoading={loading}>
          <div className="container-fluid pt-4">
            <div className='d-flex search-btn-gap challan-print'>
              {
                hasPermission('M22B1') && (
                  <div className='add-role'>
                    <Button variant="primary" className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button" onClick={this.handleMoveAdd}>
                      <i className="fa fa-plus-circle"></i> Add Measurement Bill
                    </Button>
                  </div>
                )
              }
            </div>
            <div className="col-sm-12">
              <Card>
                <Card.Header style={{ backgroundColor: "#515e73", color: "white" }}>
                  <div className="panel-title">
                    <strong>Measurement Bill List</strong>
                  </div>
                </Card.Header>
                <Card.Body>
                  <ThemeProvider theme={theme}>
                    <MaterialTable
                      title="Measurement Bills List"
                      columns={[
                        {
                          title: "ID", field: "id", editable: "never",
                          cellStyle: { minWidth: 100 },
                          headerStyle: { minWidth: 100 }
                        },
                        {
                          title: "MB Number", field: "mbNumber",
                          cellStyle: { minWidth: 120 },
                          headerStyle: { minWidth: 120 }
                        },
                        {
                          title: "Labour Name", field: "name",
                          render: (rowData) => {
                            return rowData.items
                              ?.map((item) => item.workOrderItem?.labour?.name)
                              .filter(Boolean)
                              .join(", ");
                          },
                          cellStyle: { minWidth: 120 },
                          headerStyle: { minWidth: 120 }
                        },
                        {
                          title: "MB Date",
                          field: "mbDate",
                          type: "date",
                          render: rowData => {
                            if (!rowData.mbDate) return '';
                            const date = new Date(rowData.mbDate);
                            return `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1)
                              .toString()
                              .padStart(2, '0')}/${date.getFullYear()}`;
                          },
                          cellStyle: { minWidth: 120 },
                          headerStyle: { minWidth: 120 }
                        },
                        // {
                        //   title: "MB Date---", field: "mbDate", type: "date",
                        //   cellStyle: { minWidth: 120 },
                        //   headerStyle: { minWidth: 120 }
                        // },
                        {
                          title: "Customer", field: "customer.name",
                          cellStyle: { minWidth: 250 },
                          headerStyle: { minWidth: 250 }
                        },
                        {
                          title: "Project", field: "project.name",
                          cellStyle: { minWidth: 250 },
                          headerStyle: { minWidth: 250 }
                        },
                        {
                          title: "Work Order No.", field: "workOrder.woNumber",
                          cellStyle: { minWidth: 120 },
                          headerStyle: { minWidth: 120 }
                        },
                        {
                          title: "Status", field: "status",
                          render: rowData => {
                            const status = rowData?.status;
                            const baseStyle = {
                              display: 'inline-flex',
                              alignItems: 'center',
                              gap: '6px',
                              fontSize: '0.875rem',
                              padding: '4px 12px',
                              borderRadius: '20px',
                              fontWeight: 500
                            };
                            if (status === 'Paid') {
                              return (
                                <span style={{
                                  ...baseStyle, backgroundColor: '#d1e7dd',
                                  color: '#0f5132',
                                  border: '1px solid #badbcc'
                                }}>
                                  <FaCheckCircle /> Paid
                                </span>
                              );
                            }
                            else if (status === 'Pending') {
                              return (
                                <span style={{
                                  ...baseStyle, backgroundColor: '#fff3cd',
                                  color: '#664d03',
                                  border: '1px solid #ffe69c'
                                }}>
                                  <FaHourglassHalf /> Pending
                                </span>
                              );
                            }
                            else {
                              return (
                                <span style={{
                                  ...baseStyle, backgroundColor: '#f8d7da',
                                  color: '#842029',
                                  border: '1px solid #f5c2c7'
                                }}>
                                  <FaPencilAlt /> Draft
                                </span>
                              );
                            }
                          }

                        },
                        {
                          title: "Total Item Value ", field: "status",
                          cellStyle: { minWidth: 120 },
                          headerStyle: { minWidth: 120 },
                          render: rowData => {
                            const totalValue = (rowData.items || []).reduce((sum, item) => {
                              return sum + (parseFloat(item.workOrderItem?.totalValue) || 0);
                            }, 0);

                            return `₹ ${totalValue.toFixed(2)}`;
                          }
                        },
                        {
                          title: 'Action',
                          render: rowData => (
                            <>
                              {
                                rowData.status === 'Draft' &&
                                hasPermission('M22B2') && (
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip id={`tooltip-edit-${rowData.id}`}>Edit Measurement Bill</Tooltip>}
                                  >
                                    <Button size="sm" variant="outline-info" className="mr-2 info"
                                      onClick={() => this.handleEdit(rowData)}
                                    >
                                      <i className="fa fa-edit"></i>
                                    </Button>
                                  </OverlayTrigger>
                                )}

                              {
                                hasPermission('M22B5') && (
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip id={`tooltip-print-${rowData.id}`}>Print Measurement Bill</Tooltip>}
                                  >
                                    <Button size="sm" variant="outline-info" className="mr-2 info"
                                      onClick={() => this.handlePrint(rowData)}
                                    >
                                      <i className="fa fa-print"></i>
                                    </Button>
                                  </OverlayTrigger>
                                )
                              }
                              {
                                (rowData.status === 'Pending' || rowData.status === 'Invoice') &&
                                hasPermission('M22B6') && (
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip id={`tooltip-status-${rowData.id}`}>Change Status</Tooltip>}
                                  >
                                    <Button size="sm" variant="outline-info" className="mr-2 info"
                                      onClick={() => this.handleStatusChange(rowData)}
                                    >
                                      <i className="fas fa-sync-alt"></i>
                                    </Button>
                                  </OverlayTrigger>
                                )
                              }
                              {
                                hasPermission('M22B4') && (
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip id={`tooltip-view-${rowData.id}`}>View Measurement Bill</Tooltip>}
                                  >
                                    <Button size="sm" variant="outline-info" className="mr-2 info"
                                      onClick={() => this.handleView(rowData)}
                                    >
                                      <i className="fa fa-eye"></i>
                                    </Button>
                                  </OverlayTrigger>
                                )
                              }
                              {hasPermission('M22B3') && (
                                <OverlayTrigger
                                  placement="top"
                                  overlay={<Tooltip id={`tooltip-delete-${rowData.id}`}>Delete Measurement Bill</Tooltip>}
                                >
                                  <Button size="sm" variant="outline-danger" className="mr-2 delete-btn"
                                    onClick={() => this.setState({ showConfirm: true, deleteId: rowData.id })}
                                  >
                                    <i className="fas fa-trash"></i>
                                  </Button>
                                </OverlayTrigger>
                              )}
                            </>
                          ),
                          cellStyle: { width: '220px', minWidth: '220px', textAlign: 'center' },
                          headerStyle: { width: '220px', minWidth: '220px', textAlign: 'center' }
                        }
                      ]}
                      data={measurementBills}
                      options={{
                        pageSize: 10,
                        pageSizeOptions: [10, 20, 30, 50, 75, 100],
                        rowStyle: (rowData, index) => {
                          if (index % 2) {
                            return { backgroundColor: '#f2f2f2' }
                          }
                        },
                        actionsColumnIndex: -1,
                        search: true,
                        paging: true,
                      }}
                    />
                  </ThemeProvider>
                </Card.Body>
              </Card>
            </div>
          </div>
          <Modal show={this.state.showModal} onHide={() => this.setState({ showModal: false })}>
            <Modal.Header closeButton>
              <Modal.Title>Update Status</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form>
                <Form.Group>
                  <Form.Label className="required">Select Status</Form.Label>
                  <Form.Control
                    as="select"
                    className="form-select"
                    value={this.state.newStatus}
                    onChange={(e) => this.setState({ newStatus: e.target.value })}
                  >
                    <option value="">Select</option>
                    <option value="Invoice">Invoiced</option>
                    <option value="Paid">Paid</option>
                  </Form.Control>
                </Form.Group>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button variant='danger' className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button-cancel" onClick={() => this.setState({ showModal: false })} size="sm">
                Cancel
              </Button>
              <Button variant='primary' className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button btn btn-primary" onClick={this.handleStatusUpdate} size="sm">
                Update
              </Button>
            </Modal.Footer>
          </Modal>
        </CommonLoader>
      </>
    );
  }
}